import RegistrationContainer from './RegistrationContainer';

export {
  RegistrationContainer
};

export default RegistrationContainer;
